import { Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button, EmptyState } from '../components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg px-4">
      <EmptyState
        icon={<Compass className="size-5" />}
        title="Page not found"
        description="That link does not lead anywhere in this app."
        action={<Button onClick={() => navigate('/')}>Back to dashboard</Button>}
        className="max-w-md"
      />
    </div>
  );
}

export default NotFoundPage;
